import { useState, useEffect } from 'react'
import { ArrowRight } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { content } from '../data/content'
import { lazy, Suspense } from 'react'
import SEO from '../components/SEO'

// Lazy Load components below the fold for instant Hero rendering
const StatsGrid = lazy(() => import('../components/StatsGrid'));
const ValueProps = lazy(() => import('../components/ValueProps'));
const ServiceHighlights = lazy(() => import('../components/ServiceHighlights'));
const CaseStudies = lazy(() => import('../components/CaseStudies'));
const Ecosystem = lazy(() => import('../components/Ecosystem'));
const MediaModal = lazy(() => import('../components/MediaModal'));
const ContactForm = lazy(() => import('../components/ContactForm'));

function Home() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo === 'contact') {
            const element = document.getElementById('contact');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    const headline = content.hero.headline;
    const headlineLines = headline.split('\n');

    return (
        <>
            <SEO
                title="Global MCN & Content Distribution"
                description="Go Nova Media optimizes revenue for TV series, movies, and digital creators across YouTube, Facebook, and DailyMotion with next-gen media technology."
                ogTitle="Go Nova Media | The Future of Media is Fluid"
            />
            {/* Hero Section — Static, LCP-optimised */}
            <section className="hero-standard hero">
                <div className="container" style={{ width: '95%', maxWidth: '1200px', position: 'relative' }}>

                    {/* Single Static Headline — matches skeleton exactly for perfect LCP */}
                    <div style={{ marginBottom: '32px' }}>
                        <h1 className="text-gradient">
                            {headlineLines.map((line, i) => (
                                <div key={i} style={{ width: '100%', display: 'block' }}>
                                    {line}
                                </div>
                            ))}
                        </h1>
                    </div>

                    <p className="lead-description">{content.hero.subtitle}</p>

                    <div className="cta-group" style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
                        <button
                            onClick={() => setIsModalOpen(true)}
                            className="glass-panel"
                            style={{
                                padding: '16px 48px',
                                borderRadius: '50px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                fontSize: '1.25rem',
                                fontWeight: 800,
                                background: 'white',
                                color: 'black',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), background-color 0.3s, color 0.3s'
                            }}
                        >
                            Experience Go Nova <ArrowRight size={24} />
                        </button>
                    </div>

                    <Suspense fallback={null}>
                        <MediaModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
                    </Suspense>
                </div>
            </section>

            {/* Below-the-fold sections — lazy loaded */}
            <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
                <StatsGrid />
            </Suspense>
            <Suspense fallback={<div style={{ minHeight: '600px' }} />}>
                <ServiceHighlights />
            </Suspense>
            <Suspense fallback={<div style={{ minHeight: '400px' }} />}>
                <ValueProps />
            </Suspense>
            <Suspense fallback={<div style={{ minHeight: '600px' }} />}>
                <CaseStudies />
            </Suspense>
            <Suspense fallback={<div style={{ minHeight: '700px' }} />}>
                <Ecosystem />
            </Suspense>
            <Suspense fallback={<div style={{ minHeight: '500px' }} />}>
                <ContactForm />
            </Suspense>
        </>
    );
}

export default Home;

